import React, { useEffect, useState } from "react";
import PageHeading from "../common/PageHeading";
import GalleryCardPC from "../common/GalleryCardPC";
import CustomVideoPlayer from "../common/VideoPlayer";
import { useLocation, useParams } from "react-router-dom";
import { apiHandler } from "../../utils/apiHandler";
import { EVENT_BASEURL } from "../../utils/Constants";
import { motion } from "framer-motion";


const Videos = () => {
	const { id } = useParams();
	const [response, setResponse] = useState([]);
	const [backgroundImageWeb, setBackgroundImageWeb] = useState([]);
	const [photoArr, setPhotoArr] = useState([]);
	const [videoArr, setVideoArr] = useState([]);
	const [isSticky, setIsSticky] = useState(false);
	const [currentImageIndexWeb, setCurrentImageIndexWeb] = useState(0);
	// const [handleSlideInvideo, sethandleSlideInforVideos] = useState(false); // Removed as we open in new tab
	const location = useLocation();
	const pathParts = location.pathname.split("/").filter(Boolean);
	const username = pathParts[0];
	let animationFrameId = null;

	let NewUsername = "";
	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);

	useEffect(() => {
		const fetchPhoto = async () => {
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "Gallery"
				});
				console.log(res);
				if (res) {
					setResponse(res);
					setPhotoArr(res.photosAlbums);
					setVideoArr(res.videosAlbums);
					setBackgroundImageWeb(res.basicDetails.sliderImgsMob);

				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		fetchPhoto();
	}, [])

	useEffect(() => {
		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);
	const handleSlideInforVideos = (slug, title, albumId) => {
		const targetId = albumId || id;
		const url = `/${username}/VideoPlayer/${targetId}/${slug}`;
		window.open(url, '_blank');
	};

	// Popstate listener removed as we don't use overlay anymore

	useEffect(() => {
		const interval = setInterval(() => {
			setCurrentImageIndexWeb((prev) =>
				prev === backgroundImageWeb.length - 1 ? 0 : prev + 1
			);
		}, 4000);
		return () => clearInterval(interval);
	}, [backgroundImageWeb.length]);


	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	};

	return (
		<div style={{ zIndex: '333333', backgroundColor: 'white' }}>
			{/* Overlay removed */}
			<div className="hidden sm:block">
				<div className="container-fluid p-0">
					<div className="grid grid-cols-12 h-screen">
						<div className="col-span-5 relative h-screen overflow-hidden">
							{backgroundImageWeb?.length > 0 &&
								backgroundImageWeb.map((img, index) => (
									<img
										src={newImgUrl + img}
										className={`w-full h-full relative z-[-1] object-cover crossFade__image ${currentImageIndexWeb === index ? 'crossFade__image--active' : ''
											}`}
										alt=""
									/>
								))}
							<div
								className="absolute top-0 w-full h-full py-[40px] px-[40px]"
								style={{
									background:
										"linear-gradient(0deg, rgba(0,0,0,0.9) 0%, rgba(59,59,59,0.4) 50%, rgba(0,0,0,0.9) 100%)",
								}}
							>
								<div className="w-full h-full flex justify-center items-center border-[3px] border-white text-center">
									<p className="text-white text-[70px] font-['Baby_Giovani_Script']">
										Gallery
									</p>
								</div>
							</div>
						</div>
						<div className="col-span-7">
							<div className="h-screen overflow-x-auto scroll-bar">
								<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'white', textAlign: 'center' }}>
									<PageHeading title={"Videos"} />
								</div>
								<motion.div
									className="flex flex-col "
									variants={containerVariants}
									initial="hidden"
									animate="show"
								>
									<div className="col-lg-12 d-flex justify-center pt-10 pb-3">

										<div className="grid grid-cols-1 lg:grid-cols-2 w-100 gap-10 px-10">
											{videoArr && videoArr.map((item, index) => {
												const albumId = item.albumLink ? item.albumLink.split('/').pop() : id;
												return (
													console.log("item", item),
													<motion.div
														key={index}
														variants={itemVariants}
														className="  items-start whiteripple cursor-pointer"
													>
														<GalleryCardPC
															key={item}
															paramid={id}
															data={{ title: item.albumName, cardBgImage: newImgUrl + item.albumBg }}
															title={item.albumName}
															cardBgImage={item}
															video={true}
															HandleOnclick={() => handleSlideInforVideos(item.albumName, item?.albumName, albumId)}
															isAlbum={false}
														/>
													</motion.div>
												)
											})}
										</div>

									</div>
								</motion.div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden h-dvh">
				<div className="h-full container-fluid bg-black p-0 m-0">
					<div className="h-full p-0 m-0">
						<div className="col-lg-7 col-md-6 col-sm-6 h-full p-0 m-0">
							<div className="h-full overflow-x-auto scroll-bar ">
								<div className="p-0 m-0">
									<motion.div
										className="flex flex-col "
										variants={containerVariants}
										initial="hidden"
										animate="show"
									>
										<div className="grid grid-cols-1 gap-[18px] w-100 px-3 py-3">
											{videoArr && videoArr.map((item, index) => {
												const albumId = item.albumLink ? item.albumLink.split('/').pop() : id;
												return (
													<motion.div
														key={index}
														variants={itemVariants}
														className="  items-start whiteripple cursor-pointer"
													>
														<GalleryCardPC
															videoIconColor={'white'}
															color={"black"}
															paramid={id}
															data={{ title: item.albumName, cardBgImage: newImgUrl + item.albumBg }}
															title={item.albumName}
															cardBgImage={item}
															video={true}
															key={item}
															HandleOnclick={() => handleSlideInforVideos(item.albumName, item?.albumName, albumId)}
															isAlbum={false}
														/>
													</motion.div>
												)
											})}
										</div>
									</motion.div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Videos;
